<template>
  <div>
    <v-stepper v-model="pageIndex" vertical>
      <!-- USER DATA -->
      <v-stepper-step :complete="pageIndex > 1" step="1">
        Dati Utente
      </v-stepper-step>

      <v-stepper-content step="1">
        <div>
          <StepRegisterOwner
            ref="stepRegisterOwner"
            v-bind:userData="this.registrationInfo.UserData"
          ></StepRegisterOwner>
        </div>
        <v-btn
          color="primary"
          @click="pageIndex++"
          :disabled="!this.registrationInfo.UserData.AreValid()"
        >
          Avanti
        </v-btn>
      </v-stepper-content>

      <!-- PRIVACY POLICY -->
      <v-stepper-step :complete="pageIndex > 2" step="2">
        User Agreement and Privacy Policy
      </v-stepper-step>
      <v-stepper-content step="2">
        <div>
          <StepPrivacyAgreement
            v-bind:registrationInfo="registrationInfo"
          ></StepPrivacyAgreement>
        </div>
        <v-btn
          color="primary"
          @click="submitUserData"
          :disabled="!this.registrationInfo.UserAgreementPolicy"
        >
          Avanti
        </v-btn>
        <v-btn text @click="pageIndex--"> Indietro </v-btn>
      </v-stepper-content>

      <!-- ACCOUNT VERIFICATION -->
      <v-stepper-step :complete="pageIndex > 3" step="3">
        Verifica account
      </v-stepper-step>

      <v-stepper-content step="3">
        <div>
          <StepConfirmationCode
            v-bind:userData="this.registrationInfo.UserData"
          ></StepConfirmationCode>
        </div>
        <v-btn color="primary" @click="submitActivationCode"> Avanti </v-btn> 
      </v-stepper-content>

      <v-stepper-step step="4"> Dati Azienda </v-stepper-step>

      <v-stepper-content step="4">
        <v-card>
          <StepOwnerCompanyDetails
            v-bind:registrationInfo="this.registrationInfo.CompanyData"
          ></StepOwnerCompanyDetails>
        </v-card>
        <v-btn color="primary" @click="submitCompany"> Fine </v-btn>
      </v-stepper-content>
    </v-stepper>

    <v-snackbar v-model="ShowSnackbar" :timeout="5000">
      {{ error }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error = ''">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<style lang="scss">
</style>
<script>
import StepConfirmationCode from "./Steps/StepConfirmationCode.vue";
import StepOwnerCompanyDetails from "./Steps/StepOwnerCompanyDetails.vue";
import StepRegisterOwner from "./Steps/StepRegisterOwner.vue";
import StepPrivacyAgreement from "./Steps/StepPrivacyAgreement.vue";
import EasyPlanClient from "../../utils/EasyPlanClient";
import router from "../../router/index";
export default {
  props:["page","jwt"],
  components: {
    StepRegisterOwner,
    StepOwnerCompanyDetails,
    StepConfirmationCode,
    StepPrivacyAgreement,
  },
  methods: {
    submitUserData: function () {
      EasyPlanClient.User.SignUpOwner(
        this.registrationInfo.UserData.Email,
        this.registrationInfo.UserData.Username,
        this.registrationInfo.UserData.Password
      )
        .then((res) => {
          console.debug("risposta user reg:");
          console.debug(res);
          this.registrationInfo.UserData.Token = res.data.data;
          EasyPlanClient.SetJWT(res.data.data);
          this.pageIndex++;
        })
        .catch((error) => {
          this.pageIndex--;
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error("si è verificato un errore" + this.error);
          console.error(error);
        });
    },
    submitActivationCode: function () {
      EasyPlanClient.User.ActivateUser(
        this.registrationInfo.UserData.Token,
        this.registrationInfo.UserData.ActivationCode
      )
        .then((res) => {
          console.debug("risposta user activation:");
          console.debug(res);
          EasyPlanClient.SetJWT(res.data.data);
          
          this.registrationInfo.UserData.Token = res.data.data;
          this.pageIndex++;
        })
        .catch((error) => {
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error("si è verificato un errore" + this.error);
          console.error(error);
        });
    },
    submitCompany: function () {
      if(!this.registrationInfo.CompanyData.isValid())
      {
          this.error="Inserisci  i dati dell'azienda per proseguire";
          return "";
      }
      EasyPlanClient.Company.AddCompany(
        this.registrationInfo.CompanyData.RagioneSociale,
        this.registrationInfo.CompanyData.PartitaIVA,
        this.registrationInfo.CompanyData.Indirizzo,
        this.registrationInfo.CompanyData.CAP,
        this.registrationInfo.CompanyData.City,
        this.registrationInfo.CompanyData.Province,
        this.registrationInfo.CompanyData.Telefono
      )
        .then((res) => {
          console.debug("risposta add company:");
          console.debug(res);
          let companyAlias = res.data.data;

          this.$router.push({
            name: "login",
            params: { companyAlias: companyAlias },
          });
        })
        .catch((error) => {
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error("si è verificato un errore" + this.error);
          console.error(error);
        });
    },
  },
  computed: {
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },

  data() {
    let data = {
      pageIndex: 1,
      error: "",
      registrationInfo: {
        UserData: {
          Token: "",
          ActivationCode: "",
          Username: "",
          Email: "",
          RPassword: "",
          Password: "",
          HasValidMail: function () {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(this.Email).toLowerCase());
          },
          HasValidPassword: function () {
            const r1 = /[A-Za-z]{1,}/;
            const r2 = /([0-9]{1,})/;
            return (
              r1.test(String(this.Password)) &&
              r2.test(String(this.Password)) &&
              this.Password.length >= this.MinLenPassword()
            );
            // return this.RPassword == this.Password;
          },
          MinLenPassword: function () {
            return 8;
          },
          PasswordConfirmed: function () {
            return this.RPassword == this.Password;
          },
          AreValid() {
            return (
              this.Username !== "" &&
              this.Password !== "" &&
              this.HasValidMail() &&
              this.HasValidPassword() &&
              this.PasswordConfirmed() &&
              this.Password.length >= this.MinLenPassword()
            );
          },
        },
        CompanyData: {
          RagioneSociale: "",
          PartitaIVA: "",
          Indirizzo: "",
          Telefono: "",
          CAP: "",
          City:"",
          Province:"",

          isValid(){
            return this.RagioneSociale.length>0 && this.PartitaIVA.length>0;
          }
        },
        UserAgreementPolicy: false,
      },
    };
    return data;
  },
  created(){
     //Questi dati(pagina/jwt) vengono passati dal form di login owner
     //Nel caso in cui venga interrotta la registrazione dell'utente prima che abbia completato tutti i passaggi
     //al successivo login, verrà reindirizzato qui, e queste info servono per completare la registrazione
     if(this.page>0){
           this.pageIndex=this.page;
            
          this.registrationInfo.UserData.Token = localStorage.userToken;
            EasyPlanClient.SetJWT(localStorage.userToken);
     } 
     if(this.jwt){
       this.registrationInfo.UserData.Token =this.jwt; 
          EasyPlanClient.SetJWT(this.jwt);
     }
  }
};
</script>

